export default __webpack_public_path__ + "static/Azimut-0b67168318cc6581a0bb8aec2ff14226.png";